import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
const getUnseenCount = (state) => {
    if (!state.list.dataList)
        return 0;
    return state.list.dataList.filter((b) => !b.seen).length;
};
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getUnseenCount,
};
